import { commentsData } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-500/15 text-primary-400 text-xs font-medium mb-3 whitespace-nowrap">
            吃瓜群众
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading">
            读者热评
          </h2>
          <p className="text-foreground-500 text-sm mt-2 max-w-xl mx-auto">
            来自真实读者的声音，看看大家都在讨论什么
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-5xl mx-auto">
          {commentsData.map((comment) => (
            <div
              key={comment.id}
              className="p-5 md:p-6 rounded-lg bg-background-100 border border-background-300/50 flex flex-col cursor-default"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-primary-500/20 flex items-center justify-center flex-shrink-0">
                  <span className="text-primary-400 font-bold text-sm">{comment.avatar}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-foreground-200 font-medium text-sm">{comment.name}</span>
                    <span className="px-1.5 py-0.5 rounded text-xs font-medium bg-accent-500/15 text-accent-400 whitespace-nowrap">
                      {comment.tag}
                    </span>
                  </div>
                  <span className="text-foreground-600 text-xs">{comment.time}</span>
                </div>
              </div>
              <p className="text-foreground-400 text-sm leading-relaxed flex-1">
                {comment.content}
              </p>
              <div className="flex items-center gap-1 mt-4 pt-4 border-t border-background-300/50">
                <i className="ri-thumb-up-line text-foreground-500 text-sm"></i>
                <span className="text-foreground-500 text-xs">{comment.likes.toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}